import React, { useEffect, useRef, useState } from 'react'
import Button from "@material-ui/core/Button";
import classes from './DelModal.module.css'
// Form
import { TextField } from '@material-ui/core';
// Servicios
import { endUserIdentityGet } from '../../../services/hooli-services/EndUser/EndUserIdentityGet';
import { endUserIdentityUpd } from '../../../services/hooli-services/EndUser/EndUserIdentityUpd';
// Recoil
import { useSetRecoilState, useRecoilValue } from 'recoil'
import { userCredentials, rowSelected, snackbarData, formIsOpen } from '../../../recoilState/GlobalState';
import { UsuarioHooliDel } from '../../../services/hooli-services/EndUser/UsuarioHooliDel';

export default function DelModal(props) {
    const [inRequest, setInRequest] = useState(false);
    const setIsOpen = useSetRecoilState(formIsOpen);

    const credentials = useRecoilValue(userCredentials);
    const selected = useRecoilValue(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);

    const { setProcede, updateModalList } = props.props

    async function handleClick(codigo) {
        const params = {
            "usuarioId": selected.row.id
        };

        const payload = { ...credentials, params };
        setInRequest(true);
        const response = await UsuarioHooliDel(payload);

        if (response) {
            if (response.status.code === 1) {
                setSnackbarInfo({
                    message: 'Usuario eliminado correctamente',
                    severity: 'success',
                    open: true
                });
                setInRequest(false);
                setTimeout(() => {
                    setSnackbarInfo({
                        message: '',
                        severity: 'success',
                        open: false
                    });
                    setProcede(undefined);
                    updateModalList();
                }, 3000)
            }
            else {
                setSnackbarInfo({
                    message: response.status.errmsg,
                    severity: response.status.action === 'W' ? 'warning' : 'error',
                    open: true
                });
                setInRequest(false);
                setTimeout(() => {
                    setSnackbarInfo({
                        message: '',
                        severity: 'success',
                        open: false
                    });
                }, 3000);
            }
        }
    };

    return (
        <div className={classes.container}>
            <div className={classes.column}>
                <div className={classes.containerText}>
                    <h2>Estas a punto de dar de baja operativamente al usuario, esto implica que no podra operar en la billetera ni recibir transferencias bancarias</h2>
                    <p>¿estas seguro?</p>
                </div>
                    <div className={classes.buttonRow}>
                        <Button disabled={inRequest} className={classes.button} onClick={() => handleClick("A")}>
                            Si
                        </Button>
                        <Button
                            disabled={inRequest} className={`${classes.button} ${classes.closeButton}`}
                            onClick={() => {
                                setIsOpen(false)
                                setProcede(undefined)
                            }}
                        >
                            <span>No</span>
                        </Button>
                    </div>
            </div>
        </div>
    )
}